import HomeWPPHero from "../../components/HomeWPP/HomeWPPHero/HomeWPPHero";
import WhatsAppWorld from "../../components/HomeWPP/WhatsAppWorld/WhatsAppWorld";
import ConversationFeature from "../../components/HomeWPP/ConversationFeature/ConversationFeature";
import ZYDoesTheRest from "../../components/HomeWPP/ZYDoesTheRest/ZYDoesTheRest";
import ZYPersonalities from "../../components/HomeWPP/ZYPersonalities/ZYPersonalities";
import HomeWPPFinalCTA from "../../components/HomeWPP/HomeWPPFinalCTA/HomeWPPFinalCTA";

export default function HomePage() {
  return (
    <main className="home-page">
      <HomeWPPHero />

      <WhatsAppWorld />

      <ConversationFeature
        conversation="scholarships"
        titlePalette={["#d744b5", "#e65a9d", "#f28c43"]}
      />

      <ConversationFeature
        conversation="saving"
        titlePalette={["#20c987", "#20bca3", "#209fcd"]}
      />

      <ConversationFeature
        conversation="plan"
        titlePalette={["#7b43f7", "#a547e4", "#cf4fbd"]}
      />

      <ConversationFeature
        conversation="expenses"
        titlePalette={["#c947d8", "#df4fb4", "#f05f83"]}
      />

      <ConversationFeature
        conversation="discounts"
        titlePalette={["#ff665f", "#ff7a47", "#f5a028"]}
      />

      <ConversationFeature
        conversation="money"
        titlePalette={["#20c98b", "#32aeb2", "#6375d9"]}
      />

      <ZYDoesTheRest />

      <ZYPersonalities />

      <HomeWPPFinalCTA />
    </main>
  );
}
